export type DataColor = {
  bgColor: string
  whiteText?: boolean
}

export const dataColors: DataColor[] = [
  {
    bgColor: 'bg-quinary-light',
  },
  {
    bgColor: 'bg-quinary',
  },
  {
    bgColor: 'bg-primary',
    whiteText: true,
  },
  {
    bgColor: 'bg-secondary-light',
    whiteText: true,
  },
  {
    bgColor: 'bg-secondary',
    whiteText: true,
  },
  {
    bgColor: 'bg-secondary-dark',
    whiteText: true,
  },
  {
    bgColor: 'bg-secondary-darker',
    whiteText: true,
  },
]
